








































































import {container} from "@/modules/Segmentation/services/registerServiceContainer";
import {Component, Prop, Vue} from "vue-property-decorator";
import {Agent} from "@/models/Agent";
import {IAgentService} from "@/services/IAgentService";
import {literal} from "@/components/filters/Literal";
import {IHttpService, StateMachine} from "frontend-core";
import AgentRank from "@/components/AgentRank.vue";
import {AgentList} from "@/modules/Segmentation/models/AgentList";

@Component({
  components: {AgentRank},
  filters: {
    literal,
  },
})
export default class extends Vue {
  @Prop() public readonly agentId!: string;
  @Prop() public readonly page!: string;
  agent?: Agent | null = null;
  readonly state: StateMachine = new StateMachine("idle", {
    idle: ["loading"],
    loading: ["idle"],
  });
  open: string[] = [];
  search: string = "";
  children: AgentList[] = [];
  pagination = {page: 0, lastPage: 1, pages: []};

  private readonly agentService: IAgentService = container.resolve("IAgentService");
  private readonly httpService: IHttpService = container.resolve("IHttpService");

  get loadingState(): boolean {
    return this.state.state === 'loading';
  }

  async mounted(): Promise<void> {
    this.state.transition("loading");
    this.agent = null;
    this.agent = await this.agentService.get(this.agentId);
    await this.load();
    this.state.transition("idle");
  }

  async changePage(newPage: number): Promise<void> {
    if (newPage === +this.page)
      return;
    await this.$router.push({path: `/${this.agentId}/children/${newPage}`});
    await this.load();
  }

  async getAgents(id: string | undefined, page: number, search: string = ''): Promise<{ items: AgentList[], pagination: { page: number, perPage: number, totalItemCount: number } }> {
    const {items, pagination} = (await this.httpService.api.get(`agents/${id}/list?page=${page}&name=${search}`)).data;

    return {items: items.map((el: any) => new AgentList(el)), pagination: pagination};
  }

  async loadChildren(item: AgentList): Promise<void> {
    const {items, pagination} = await this.getAgents(item.id, 1);
    item.children = items as AgentList[];
    for (let i = 1; i < Math.ceil(pagination.totalItemCount / pagination.perPage); ++i) {
      const {items} = await this.getAgents(item.id, i + 1);
      item.children = item.children.concat(items);
    }
    AgentList.sortChildren(item.children);
  }

  async _loadAgents(id: string, page: string | number, search: string = ''): Promise<void> {
    this.state.transition("loading");
    this.children = [];
    const {items, pagination} = await this.getAgents(this.agent?.id, +page, search);
    this.children = items;
    this.pagination.page = pagination.page;
    this.pagination.lastPage = pagination.totalItemCount / pagination.perPage;
    this.state.transition("idle");
  }

  async load(): Promise<void> {
    if (this.agent?.id)
      await this._loadAgents(this.agent?.id, this.page, this.search);
  }

  async findAgent(): Promise<void> {
    if (!this.search) {
      this.search = ''; /** Очистка поля заNULLивает переменную, в результате на бэк отправляется name=null **/
      await this.load();
    }
    if (this.agent?.id) {
      await this._loadAgents(this.agent?.id, 1, this.search);
      if (+this.page !== 1)
          await this.$router.push({path: `/${this.agentId}/children/1`});
    }
  }

  filter(item: Agent, search: string): boolean {
    return item.name.toLocaleLowerCase().includes(search.toLocaleLowerCase());
  }
}

